export default __webpack_public_path__ + "static/media/Bandeau-catalogue-tablette.fe22a277.png";